import { API_URL_WEBINAR } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getWebinars = () =>
  apiInstance({
    url: API_URL_WEBINAR,
    params: {
      limit: 5000,
    },
  });

export default getWebinars;
